/** @format */

import {oklch, formatHex} from 'culori';

import {OKLCH_DEFAULT_COLOR} from '../constants/widgets';

const getHexByHue = (hue: number): string => {
  const oklchColor = {
    ...OKLCH_DEFAULT_COLOR,
    h: hue,
  };

  return formatHex(oklch(oklchColor));
};

export default getHexByHue;
